import { useStoreActions, useStoreState } from '@/stores/store';

export function useGlobalStateInHome() {
  // States
  const chosenSets = useStoreState((state) => state.chosenSets);
  const sets = useStoreState((state) => state.sets);
  const lastSyncedSets = useStoreState((state) => state.lastSyncedSets);
  const isPatientDemo = useStoreState((state) => state.isPatientDemo);
  const signedInUser = useStoreState((state) => state.signedInUser);

  // Actions
  const chooseSetToExercise = useStoreActions(
    (actions) => actions.chooseSetToExercise,
  );
  const setIsPatientDemo = useStoreActions(
    (actions) => actions.setIsPatientDemo,
  );

  const setPatientSettings = useStoreActions(
    (actions) => actions.setPatientSettings,
  );
  const setPatientSets = useStoreActions((actions) => actions.setPatientSets);
  const resetChosenSets = useStoreActions((actions) => actions.resetChosenSets);
  const setLastSyncedSets = useStoreActions(
    (actions) => actions.setLastSyncedSets,
  );
  const changeActivePatient = useStoreActions(
    (actions) => actions.changeActivePatient,
  );

  return {
    chosenSets,
    sets,
    lastSyncedSets,
    isPatientDemo,
    chooseSetToExercise,
    setIsPatientDemo,
    setPatientSettings,
    setPatientSets,
    resetChosenSets,
    setLastSyncedSets,
    changeActivePatient,
    signedInUser,
  };
}
